module.exports = __webpack_public_path__ + "static/media/proj15.44b0b789.jpg";